import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule} from "../../../shared/shared.module";
import {JBMDocumentViewerComponent} from "./JBMDocumentViewer/JBMDocumentViewer.component";

@NgModule({
  declarations: [JBMDocumentViewerComponent],
  imports: [CommonModule, SharedModule],
  exports: [JBMDocumentViewerComponent]
})
export class JBMMediaModule { }
